import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('RadioOpeningContent', null, { withChildren: true });
